import { Box } from '@mui/material';

import LoadingIndicator from './LoadingIndicator';

export function LoadingOverlay({ backgroundColor = 'success.secondary' }) {
    return (
        <Box
            sx={{
                position: 'absolute',
                width: 1,
                height: 1,
                overflow: 'hidden',
                backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'default'
            }}
        >
            <LoadingIndicator />
        </Box>
    );
}
